jQuery(document).ready(function($) {

  $('#menu-opener').click(function() {
    if($(this).attr('aria-expanded') === "false") {
      $('.mobile-logo.menu-closed').addClass('hide');
      $('.mobile-logo.menu-open').removeClass('hide');
      $('header.header').addClass('menu-open');
    } else {
      $('.mobile-logo.menu-closed').removeClass('hide');
      $('.mobile-logo.menu-open').addClass('hide');
      $('header.header').removeClass('menu-open');
    }

  });

  $('#mobile-nav .menu.submenu a[href*="#"][aria-current="page"]').click(function() {
    $('#off-canvas').foundation('close');
    $('.mobile-logo.menu-closed').removeClass('hide');
    $('.mobile-logo.menu-open').addClass('hide');
    $('header.header').removeClass('menu-open');
  });

  $('header.header').on('sticky.zf.stuckto:top', function() {
    // console.log('wup');
    animateHeader();

  });

  $('header.header').on('sticky.zf.unstuckfrom:top', function() {
    // console.log('w0p');
    animateHeader();
  });

  if($('header.header .current-post-parent').length) {
    $('header.header .current-post-parent').parents('.submenu').attr('style', 'display: flex !important');
    $('header.header .current-post-parent').parents('.submenu').parents('.is-dropdown-submenu-parent').addClass('active');
  }

  function animateHeader() {

    var group = document.querySelector(".desktop-menu");
    // var nodes = document.querySelectorAll(".desktop-menu>li");
    // var total = nodes.length;
    // var ease  = Power1.easeInOut;
    // var boxes = [];
    //
    // for (var i = 0; i < total; i++) {
    //
    //   var node = nodes[i];
    //
    //   // Initialize transforms on node
    //   TweenLite.set(node, { x: 0, y: 0 });
    //
    //   boxes[i] = {
    //     transform: node._gsTransform,
    //     x: node.offsetLeft,
    //     y: node.offsetTop,
    //     node
    //   };
    // }

    group.classList.toggle("stuckish");

    // for (var i = 0; i < total; i++) {
    //   var box = boxes[i];
    //
    //   var lastX = box.x;
    //   var lastY = box.y;
    //
    //   box.x = box.node.offsetLeft;
    //   box.y = box.node.offsetTop;
    //
    //   // Continue if box hasn't moved
    //   if (lastX === box.x && lastY === box.y) continue;
    //
    //   // Reversed delta values taking into account current transforms
    //   var x = box.transform.x + lastX - box.x;
    //   var y = box.transform.y + lastY - box.y;
    //
    //   // Tween to 0 to remove the transforms
    //   TweenLite.fromTo(box.node, 0.5, { x, y }, { x: 0, y: 0, ease, onComplete: function() {
    //     box.node.style.transform = 'none';
    //   }});
    //
    //
    // }
  }
});
